import React from 'react';
import IconFromPath from '../IconFromPath/IconFromPath';
import Callout from './Callout';

const ArrowIcon = props => (
    <IconFromPath {...props} Path={Callout} />
);

export default ArrowIcon;
